import '../../../../Assets/app.base';
import './Competition.scss';

// Components
import '../../../../Components/Carousel';
import '../../../../Components/Countdown';
import '../../../../Components/ViewTracker';
import '../../../../Components/ParentingAssignmentDownload';

// Helper
import inlineForm from '../../../../Assets/scripts/forms/inlineForm';

function bind(element) {
    element.find('#form-field-email-info-trigger').click(e => {
        e.preventDefault()
        element.find('#form-field-email-info-target').toggle()
    })
    element.find('#form-field-confirmation-info-trigger').click(e => {
        e.preventDefault()
        element.find('#form-field-confirmation-info-target').toggle()
    })
}

function init() {
    const form = $('#form-target')

    if (form) { inlineForm(form, bind) }
}

$(function () {
    init()
})